<template>
<ScrollPanel style="width: 100%; height: 140px;">
<draggable 
v-model="the_node.logic_bundles"
class="logic_bundle_wrap" 
v-bind="dragOptions"
handle=".handle"
item-key="id">
<template #item="{element,index}" >

<div class="grid " >
<div class="col-fixed" style="width:20px">
  <i class="pi pi-sort-alt handle mr-2"></i>
</div>
<div class="col-fixed" style="width:105px">
<p class="text-primary text-sm m-0 mt-1 the_elipsis cursor-pointer" 
v-tooltip.left="getBundleTitle(element.id,index)"
@click="showBundle(element.id)"
>{{getBundleTitle(element.id,index)}}</p>
</div>

<div class="col-fixed" style="width:30px">
  <Button  icon="pi pi-trash" @click="deleteBundle($event,element.id)"   class=" p-button-danger p-button-text  mr-2 p-0" style="height:26px" />
</div>
</div>





</template>
</draggable>
</ScrollPanel>

<hr class="m-1">
<Button icon="pi pi-plus"  label="Yeni Koşul" class="p-button-outlined p-button-sm p-button-primary p-1 m-0"   @click="addLogicBundle"></Button>

<LogicBundle ref="logicbundle" :inputs="inputs" @conditionUpdated="conditionUpdated"/>
<ConfirmPopup group="deletebundle"></ConfirmPopup>

</template>

<script>
const logic_bundle_model = {
  id:null,
  title:null,
  conditions:[],
  outcome:null,
  collapsed:false
}
const conditionmodel = {
		id:null,
	    type:null,//inputfield,customattribute
	    comparison_type:null,
	    selected_input:null,
	    comparison_input:null,
	    text_val:null,
	    numerical_val:null,
	    execution_type:null,
	    operator:null,
		}

import LogicBundle from "./LogicBundle"
export default {

  name: 'ConditionalLogic',
  props:["inputs","node"],
  data () {
    return {
      the_node:{
        logic_bundles:[]
      },
      selectedbundle:null,
    }
  },  
  components:{LogicBundle},
  computed:{  	
  	dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
  },
  mounted()
  {
    if(this.node)
    {
      this.the_node = this.node
    }
  },
  methods:{
    conditionUpdated(bundle)
    {
      console.log("conditionUpdated")
      console.log(bundle)
      console.log(this.the_node.logic_bundles)
    },
    deleteBundle(event,id)
    {
      this.$confirm.require({
          target: event.currentTarget,
          group: 'deletebundle',
          message: this.$store.state.languages.lang_phrases.bu_kaydi_silmek_istiyor_musunuz,
          header: this.$store.state.languages.lang_phrases.silme_uyarisi,
          icon: 'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger p-button-outlined',
          acceptLabel:this.$store.state.languages.lang_phrases.devam_et,
          rejectLabel:this.$store.state.languages.lang_phrases.iptal,
          accept: () => {
              this.submitDeleteBundle(id)
          },
          reject: () => {              
          }
      });
      
    },
    submitDeleteBundle(id)
    {
      console.log("deleteBundle");
      console.log(id);
      console.log(this.the_node);
      this.the_node.logic_bundles = this.the_node.logic_bundles.filter(item=>item.id !==id)
      this.updateNodeData(this.the_node)
    },
    updateCollapsed(data,index)
    {      
      this.the_node.logic_bundles[index].collapsed = data
      this.updateNodeData(this.the_node)
    },
    getBundleTitle(id,index)
    {
      let bundle = this.the_node.logic_bundles.find(item=>item.id == id)
      let first_condition = bundle.conditions[0]
      if(first_condition.selected_input)
      {
        return first_condition.selected_input.title
      }
      else
      {
        return "karşılaştırma "+(index+1)
      }
    },
  	addLogicBundle()
    {
      let logic_bundle = this.sanitizeArray(logic_bundle_model)
      logic_bundle.id = this.generateId()
      let condition = this.sanitizeArray(conditionmodel)
      condition.id = this.generateId()
      logic_bundle.conditions.push(condition)
      this.the_node.logic_bundles.push(logic_bundle)
      this.updateNodeData(this.the_node)
      setTimeout(()=>{
        this.showBundle(logic_bundle.id)
      })
      
    },
    showBundle(id)
    {
      let selectedbundle = this.node.logic_bundles.find(item=>item.id == id)
      this.$refs.logicbundle.showModal(selectedbundle)
    },
    updateNodeData(selectednode)
  	{
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == selectednode.id})
  		nodes[ind] = selectednode
  		this.$store.dispatch('calculations/setNodes',nodes)
      this.$store.dispatch('calculations/setSelectedNode',selectednode)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>